"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionEnum = void 0;
var PositionEnum;
(function (PositionEnum) {
    PositionEnum[PositionEnum["INTERN"] = 0] = "INTERN";
    PositionEnum[PositionEnum["UX_DESIGNER"] = 1] = "UX_DESIGNER";
    PositionEnum[PositionEnum["DEVELOPER"] = 2] = "DEVELOPER";
    PositionEnum[PositionEnum["FINANCE_WORKER"] = 3] = "FINANCE_WORKER";
    PositionEnum[PositionEnum["TEAM_LEAD"] = 4] = "TEAM_LEAD";
    PositionEnum[PositionEnum["DEPARTMENT_LEAD"] = 5] = "DEPARTMENT_LEAD";
    PositionEnum[PositionEnum["CFO"] = 6] = "CFO";
    PositionEnum[PositionEnum["CTO"] = 7] = "CTO";
    PositionEnum[PositionEnum["CPO"] = 8] = "CPO";
    PositionEnum[PositionEnum["CEO"] = 9] = "CEO";
})(PositionEnum = exports.PositionEnum || (exports.PositionEnum = {}));
